type PasswordResetState = {
  correlationId: string | null
  maskedEmail: string | null
  email: string | null
  expiresInSeconds: number
}

let state: PasswordResetState = {
  correlationId: null,
  maskedEmail: null,
  email: null,
  expiresInSeconds: 300,
}

export function getPasswordResetState(): PasswordResetState {
  return state
}

export function setPasswordResetStarted(
  correlationId: string,
  maskedEmail: string,
  expiresInSeconds: number,
  email: string,
) {
  state = { correlationId, maskedEmail, expiresInSeconds, email }
}

export function resetPasswordReset() {
  state = { correlationId: null, maskedEmail: null, email: null, expiresInSeconds: 300 }
}
